<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Hero Section -->
    <section class="relative overflow-hidden" style="background: linear-gradient(to bottom right, #A3E4DB, #C4E49F);">
      <div class="absolute inset-0 bg-white/30 backdrop-blur-sm"></div>

      <!-- Hero Content -->
      <div class="relative container mx-auto px-4 sm:px-6 py-8 sm:py-12 lg:py-16">
        <div class="text-center text-gray-800">
          <h1 class="text-3xl sm:text-4xl lg:text-6xl font-bold mb-6 leading-tight">
            聯繫 <span style="color: #F4D35E;">智光系統</span>
          </h1>
          <p class="text-lg sm:text-xl lg:text-2xl mb-8 text-gray-700 leading-relaxed max-w-3xl mx-auto">
            我們隨時準備為您提供專業的企業管理系統諮詢服務
          </p>

          <!-- Contact Pills -->
          <div class="flex flex-wrap gap-3 sm:gap-4 mb-8 justify-center">
            <span
              class="px-4 sm:px-6 py-2 bg-white/70 rounded-full text-sm sm:text-base font-medium text-gray-700 shadow-sm">
              專業諮詢
            </span>
            <span
              class="px-4 sm:px-6 py-2 bg-white/70 rounded-full text-sm sm:text-base font-medium text-gray-700 shadow-sm">
              快速回應
            </span>
            <span
              class="px-4 sm:px-6 py-2 bg-white/70 rounded-full text-sm sm:text-base font-medium text-gray-700 shadow-sm">
              客製化服務
            </span>
          </div>
        </div>
      </div>

      <!-- Decorative Elements -->
      <div class="absolute top-0 right-0 w-1/3 h-full opacity-10">
        <div class="w-full h-full bg-gradient-to-l from-white to-transparent"></div>
      </div>
    </section>

    <!-- Contact Form Section -->
    <section class="py-20 bg-gray-100">
      <div class="container mx-auto px-6">
        <div class="max-w-4xl mx-auto">
          <div class="text-center mb-12">
            <h2 class="text-4xl font-bold text-gray-800 mb-4">聯絡表單</h2>
            <p class="text-xl text-gray-600">
              填寫以下表單，我們將儘快與您聯繫
            </p>
          </div>

          <div class="bg-white rounded-2xl shadow-xl p-8 lg:p-12">
            <form @submit.prevent="submitForm" class="space-y-6 text-lg">
              <div class="grid md:grid-cols-2 gap-6">
                <!-- Name -->
                <div>
                  <label for="name" class="block font-medium text-gray-700 mb-2 text-lg">
                    姓名 <span class="text-red-500">*</span>
                  </label>
                  <input type="text" id="name" v-model="form.name"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200 placeholder:text-lg text-lg"
                    placeholder="請輸入您的姓名" required>
                </div>

                <!-- Phone -->
                <div>
                  <label for="phone" class="block font-medium text-gray-700 mb-2 text-lg">
                    聯絡電話 <span class="text-red-500">*</span>
                  </label>
                  <input type="tel" id="phone" v-model="form.phone"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200 placeholder:text-lg text-lg"
                    placeholder="請輸入您的聯絡電話" required>
                </div>
              </div>

              <div class="grid md:grid-cols-2 gap-6">
                <!-- Email -->
                <div>
                  <label for="email" class="block font-medium text-gray-700 mb-2 text-lg">
                    電子信箱 <span class="text-red-500">*</span>
                  </label>
                  <input type="email" id="email" v-model="form.email"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200 placeholder:text-lg text-lg"
                    placeholder="請輸入您的電子信箱" required>
                </div>

                <!-- Company -->
                <div>
                  <label for="company" class="block font-medium text-gray-700 mb-2 text-lg">
                    公司名稱
                  </label>
                  <input type="text" id="company" v-model="form.company"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200 placeholder:text-lg text-lg"
                    placeholder="請輸入您的公司名稱">
                </div>
              </div>

              <!-- Service Interest -->
              <div>
                <label for="service" class="block font-medium text-gray-700 mb-2 text-lg">
                  感興趣的服務
                </label>
                <select id="service" v-model="form.service"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200 placeholder:text-lg text-lg">
                  <option value="">請選擇感興趣的服務</option>
                  <option value="智光系統">智光系統項目</option>
                  <option value="進存服務">進存服務項目</option>
                  <option value="智光i學園">智光i學園</option>
                  <option value="客製化開發">客製化開發</option>
                  <option value="系統整合">系統整合</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              <!-- Message -->
              <div>
                <label for="message" class="block font-medium text-gray-700 mb-2 text-lg">
                  訊息內容 <span class="text-red-500">*</span>
                </label>
                <textarea id="message" v-model="form.message" rows="6"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200 resize-none placeholder:text-lg text-lg"
                  placeholder="請詳細描述您的需求或問題..." required></textarea>
              </div>

              <!-- Privacy Policy -->
              <div class="flex items-start">
                <input type="checkbox" id="privacy" v-model="form.privacy"
                  class="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" required>
                <label for="privacy" class="ml-3 text-gray-600 text-lg">
                  我已閱讀並同意 <a href="#" class="text-blue-600 hover:text-blue-800">隱私權政策</a> 和 <a href="#"
                    class="text-blue-600 hover:text-blue-800">服務條款</a> <span class="text-red-500">*</span>
                </label>
              </div>

              <!-- Submit Button -->
              <div class="text-center pt-6">
                <button
                  class="text-black px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold text-base sm:text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                  style="background-color: #F4D35E; --tw-bg-opacity: 1;"
                  onmouseover="this.style.backgroundColor='#fce788'"
                  onmouseout="this.style.backgroundColor='#F4D35E'"
                >
                  <span v-if="!isSubmitting">送出表單</span>
                  <span v-else class="flex items-center justify-center">
                    <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg"
                      fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                      </path>
                    </svg>
                    送出中...
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Info Section -->
    <section class="py-20 bg-white">
      <div class="container mx-auto px-6">
        <div class="text-center mb-16">
          <h2 class="text-4xl font-bold text-gray-800 mb-4">聯絡與辦公室資訊</h2>
          <p class="text-xl text-gray-600 max-w-2xl mx-auto">
            多種聯繫方式，歡迎隨時與我們保持聯繫
          </p>
        </div>

        <div class="grid lg:grid-cols-2 gap-12 items-stretch">
<!-- Contact Info + Office Info -->
<div
  class="bg-gradient-to-br from-blue-50 via-teal-50 to-green-50 p-8 rounded-2xl shadow-md flex flex-col justify-between min-h-[480px]">
  <!-- 聯絡方式 -->
  <div class="flex-1">
    <h3 class="text-2xl font-bold text-gray-800 mb-6">聯絡資訊</h3>
    <div class="flex justify-center space-x-16">
      <!-- Phone -->
      <div class="flex flex-col items-center text-center max-w-xs">
        <div class="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style="background-color: #E9967A;">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
        </div>
        <p class="font-semibold text-gray-800">服務專線</p>
        <p class="text-[#E9967A]">04-23149911</p>
        <p class="text-sm text-gray-600">週一至週五 9:00-18:00</p>
      </div>

      <!-- Email -->
      <div class="flex flex-col items-center text-center max-w-xs">
        <div class="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style="background-color: #A6C48A;">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        <p class="font-semibold text-gray-800">電子信箱</p>
        <p class="text-[#A6C48A]">bryte.edu@gamil.com</p>
        <p class="text-sm text-gray-600">24小時內回復</p>
      </div>

      <!-- LINE -->
      <div class="flex flex-col items-center text-center max-w-xs">
        <div class="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style="background-color: #5FB4BF;">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </div>
        <p class="font-semibold text-gray-800">LINE 官方帳號</p>
        <p class="text-[#5FB4BF]">@zhiguang</p>
        <p class="text-sm text-gray-600">即時客服支援</p>
      </div>
    </div>
  </div>
  <!-- 辦公室位置 -->
  <div class="mt-8 pt-8 border-t border-gray-200">
    <h3 class="text-2xl font-bold text-gray-800 mb-4">辦公室位置</h3>
    <div class="space-y-2">
      <p><strong>地址：</strong>台中市西屯區西屯路二段256巷6號3號樓之5</p>
      <p><strong>營業時間：</strong>週一至週五 09:00 - 18:00</p>
    </div>
  </div>
</div>


          <!-- Map -->
          <div class="bg-gray-200 rounded-2xl overflow-hidden shadow-lg min-h-[480px]">
            <iframe class="w-full h-full min-h-[480px]"
              src="https://www.google.com/maps?q=台中市西屯區西屯路二段256巷6號3號樓之5&output=embed" style="border:0;"
              allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import Swal from 'sweetalert2'

// 表單資料
const form = reactive({
  name: '',
  phone: '',
  email: '',
  company: '',
  service: '',
  message: '',
  privacy: false
})

// 提交狀態
const isSubmitting = ref(false)


// 提交表單
const submitForm = async () => {
  if (!form.name || !form.phone || !form.email || !form.message || !form.privacy) {
    Swal.fire({
      icon: 'warning',
      title: '請填寫所有必填欄位並同意隱私權政策',
      confirmButtonColor: '#3085d6',
      confirmButtonText: '好的'
    })
    return
  }

  isSubmitting.value = true

  try {
    // 模擬 API 調用
    await new Promise(resolve => setTimeout(resolve, 2000))

    await Swal.fire({
      icon: 'success',
      title: '表單提交成功！',
      text: '我們將儘快與您聯繫。',
      confirmButtonColor: '#3085d6',
      confirmButtonText: '確定'
    })

    // 重置表單
    Object.keys(form).forEach(key => {
      if (typeof form[key] === 'boolean') {
        form[key] = false
      } else {
        form[key] = ''
      }
    })
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: '提交失敗',
      text: '請稍後再試。',
      confirmButtonColor: '#d33',
      confirmButtonText: '重試'
    })
  } finally {
    isSubmitting.value = false
  }
}
</script>

<style lang="scss" scoped>
// 修正 z-index 層級問題
.text-gray-800 {
  position: relative;
  z-index: 1;
}

// Hero section 的背景層級
.absolute.inset-0 {
  z-index: 0;
}

// 裝飾元素層級
.absolute.top-0.right-0 {
  z-index: 0;
}

section.bg-white {
  position: relative;
  z-index: 1;
}

// 表單焦點樣式
input:focus,
select:focus,
textarea:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

// Hero 區域動畫
.hero-content {
  animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 聯絡資訊卡片進場動畫
.contact-card {
  animation: slideInUp 0.8s ease-out forwards;
  opacity: 0;
  transform: translateY(50px);

  &:nth-child(1) {
    animation-delay: 0.1s;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.3s;
  }

  &:nth-child(4) {
    animation-delay: 0.4s;
  }
}

@keyframes slideInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 聯絡資訊卡片 hover 效果增強
.group {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  }

  .group-hover\:scale-110 {
    transition: transform 0.3s ease;
  }
}

// 表單區域動畫
.form-container {
  animation: fadeIn 1s ease-out 0.5s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

// 表單輸入框動畫效果
input,
select,
textarea {
  transition: all 0.3s ease;
  position: relative;

  &:focus {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.15);
  }

  &:hover:not(:focus) {
    border-color: #93c5fd;
  }
}

// 提交按鈕動畫
button[type="submit"] {
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  &:hover:before {
    left: 100%;
  }

  &:hover:not(:disabled) {
    box-shadow: 0 15px 35px rgba(251, 191, 36, 0.4);
  }
}

// FAQ 展開動畫
.faq-item {
  transition: all 0.3s ease;

  .faq-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
  }

  &.open .faq-content {
    max-height: 200px;
    padding-bottom: 1rem;
  }
}

// 地圖區域動畫
.map-container {
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(59, 130, 246, 0.1), rgba(16, 185, 129, 0.1));
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
  }

  &:hover:before {
    opacity: 1;
  }
}

// 辦公室資訊卡片動畫
.office-info-card {
  transform: translateX(50px);
  opacity: 0;
  animation: slideInLeft 0.8s ease-out 0.3s forwards;
}

@keyframes slideInLeft {
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

// 響應式動畫優化
@media (prefers-reduced-motion: reduce) {

  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

// 滾動觸發動畫 (需要配合 JavaScript)
.scroll-reveal {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;

  &.revealed {
    opacity: 1;
    transform: translateY(0);
  }
}

// Pills 動畫效果
.contact-pills span {
  transition: all 0.3s ease;
  animation: float 3s ease-in-out infinite;

  &:nth-child(1) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: 0.5s;
  }

  &:nth-child(3) {
    animation-delay: 1s;
  }

  &:hover {
    transform: translateY(-5px) scale(1.05);
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }
}

// Loading 動畫優化
.loading-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

// 成功提交動畫
.form-success {
  animation: bounceIn 0.6s ease;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

// 錯誤狀態樣式
.form-error {
  animation: shake 0.5s ease-in-out;
  border-color: #ef4444 !important;
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-5px);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translateX(5px);
  }
}

// 漸層背景動畫
.gradient-bg {
  background-size: 200% 200%;
  animation: gradientShift 8s ease infinite;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

// 微互動效果
.micro-interaction {
  transition: all 0.2s ease;

  &:active {
    transform: scale(0.98);
  }
}

// 文字打字動畫
.typewriter {
  overflow: hidden;
  border-right: 2px solid;
  white-space: nowrap;
  margin: 0 auto;
  animation: typing 3.5s steps(40, end), blink-caret 0.75s step-end infinite;
}

@keyframes typing {
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
}

@keyframes blink-caret {

  from,
  to {
    border-color: transparent;
  }

  50% {
    border-color: currentColor;
  }
}

// 粒子效果背景 (裝飾用)
.particles {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &:before,
  &:after {
    content: '';
    position: absolute;
    width: 4px;
    height: 4px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    animation: particle 8s linear infinite;
  }

  &:before {
    left: 20%;
    animation-delay: 0s;
  }

  &:after {
    left: 80%;
    animation-delay: 4s;
  }
}

@keyframes particle {
  0% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0;
  }

  10% {
    opacity: 1;
  }

  90% {
    opacity: 1;
  }

  100% {
    transform: translateY(-100px) rotate(360deg);
    opacity: 0;
  }
}
</style>